<template>
    <v-tabs
            center-active
            centered="centered"
            background-color="#F4F5F6"
            v-model="activeTab"
            height="61"
            class="about-tabs"
            slider-size="3"
    >
        <v-tab
                v-for="tab in tabs"
                :key="tab.index"
                @click="updateUrl($event, tab.toUrl)"
        >
            {{tab.name}}
        </v-tab>

        <v-tab-item>
            <About />
        </v-tab-item>

        <v-tab-item>
            <Terms />
        </v-tab-item>

        <v-tab-item>
           <Policy />
        </v-tab-item>

        <v-tab-item>
            <Contact />
        </v-tab-item>

        <v-tab-item>
            <Unsubscribe />
        </v-tab-item>
    </v-tabs>
</template>

<script>
    import About from "./About";
    import Terms from "./Terms";
    import Policy from "./Policy";
    import Contact from "./Contact";
    import Unsubscribe from "./Unsubscribe";
export default {

  name: 'SiteInfo',
    components: {
      About,
        Terms,
        Policy,
        Contact,
        Unsubscribe
    },
    watch: {
        $route (to) {
            this.switchActiveTab(to.name);
        }
    },
    data: () => ({
        activeTab: 0,
        tabs: [
            { index: 0, name: 'About', toUrl: '/about' },
            { index: 1, name: 'Terms', toUrl: '/terms' },
            { index: 2, name: 'Policy', toUrl: '/policy' },
            { index: 3, name: 'Contact', toUrl: '/contact' },
            { index: 3, name: 'Unsubscribe', toUrl: '/unsubscribe' },
        ]
    }),
    methods: {
        switchActiveTab(tabName) {
            switch (tabName) {
                case 'About':
                    this.activeTab = 0;
                    break;
                case'Terms':
                    this.activeTab = 1;
                    break;
                case 'Policy':
                    this.activeTab = 2;
                    break;
                case 'Contact':
                    this.activeTab = 3;
                    break;
                case 'Unsubscribe':
                    this.activeTab = 4;
                    break;
                default:
                    this.activeTab = 0;
            }
        },
        updateUrl(event, url) {
            event.preventDefault();

            this.$router.push(url);
        }
    },
    beforeMount() {
        this.switchActiveTab(this.$router.currentRoute.name);
    },
}
</script>

<style scoped>
    .justify-center {
        justify-content: center;
        border: 1px solid red;
    }
    .about-tabs .v-tab {
        text-transform: unset;
        letter-spacing: 0;
        color: #000;
        font-size: 14px;
        font-weight: 400;
    }

</style>
